module.exports = __webpack_public_path__ + "img/1_05.fce9f5ef.jpg";